class AbstractBase {
    constructor() {
        if (this.constructor === BaseComponent) {
            throw new Error(`${this} is an Abstract class and can not be instantiated! `)
        }
    }
}

const BaseComponentMixin = (Base) => class extends Base {
    state = {};

    #validateStateFunctionParameters(value) {
        if (typeof value === 'function') {
            return value(this.state);
        } else if (typeof value === 'object') {
            return value;
        } else {
            throw new Error('Invalid type of params');
        }
    }

    setState(args) {
        const params = this.#validateStateFunctionParameters(args);
        for (const [key, value] of Object.entries(this.state)) {
            if (typeof params[key] === 'undefined') continue;
            this.state[key] = params[key];
        }
    }
}

class BaseWebComponent extends HTMLElement {
    static define(tag) {
        try {
            customElements.define(tag, this);
        } catch (err) {
            throw new Error(`Couldn't define ${tag} element`);
        }
    }
}

class EventComponent extends BaseComponentMixin(EventTarget) {
};

class WebComponent extends BaseComponentMixin(BaseWebComponent) {
};

class BaseComponent extends BaseComponentMixin(AbstractBase) {
};


export default {BaseComponent, EventComponent, WebComponent};
